<template>
    <v-simple-table dense :class="classList">
        <tbody>
            <tr v-for="(row, key) in value" :key="key">
                <th>{{ key }}</th>
                <td>
                    <div v-if="typeof row === 'object'">
                        <app-table-nested :value="row" />
                    </div>
                    <div v-else>
                        {{ row }}
                    </div>
                </td>
            </tr>
        </tbody>
    </v-simple-table>
</template>

<script>
export default {
    name: 'AppTableNested',
    props: {
        value: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        classList() {
            let classList = ['app-table', 'app-table-nested', `app-table--${this.uuid}`];

            classList.push('app-table--outlined');

            classList.push(`app-table--layout--auto`);

            return classList;
        }
    }
};
</script>
